import { ICommand } from "Application";
import { Box, Button, EditDate, EditSelect, Label } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import React from "react";
import { AddStudentViewModel } from "./AddStudentViewModel";
import { observer } from "mobx-react-lite";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { ClockIcon } from "Assets/Icons/ClockSVG";
import { Container, Footer, ButtonGroup, StyledDialog, Header, FormField, TransportSection } from "./AddStudentView.styles";

export interface IProps {
    onCancel: () => void;
    parentViewModel: WeeklyRotaDetailsViewModel;
    viewModel: AddStudentViewModel;
}

const AddStudentView: React.FC<IProps> = observer(({ onCancel, parentViewModel, viewModel }: IProps) => {
    const saveCommand = viewModel.saveMentorStudentCommand(parentViewModel, onCancel);
    const closeCommand = viewModel.closeCommand(onCancel);
    const updateStudentCommand = viewModel.updateStudentWithPreFillCommand(parentViewModel);

    return (
        <StyledDialog open={true}>
            <Header>
                Add student
                <CloseIcon onClick={closeCommand.execute} />
            </Header>
            <Container>
                <StudentSelectSection viewModel={viewModel} command={updateStudentCommand} />
                <TransportDetailsSection viewModel={viewModel} />
                <AddStudentFooter viewModel={viewModel} saveCommand={saveCommand} closeCommand={closeCommand} />
            </Container>
        </StyledDialog>
    );
});

const StudentSelectSection: React.FC<{ viewModel: AddStudentViewModel; command: ICommand }> = ({ viewModel, command }) => (
    <Box>
        <FormField>
            <EditSelect
                displayName="Select Student"
                placeholder="Type name of student or select from dropdown"
                value={() => viewModel.getValue("selectedStudentId")}
                options={viewModel.studentOptions}
                validationMessage={() => viewModel.getError("selectedStudentId")}
                command={command}
            />
        </FormField>
    </Box>
);

const TransportDetailsSection: React.FC<{ viewModel: AddStudentViewModel }> = observer(({ viewModel }) => (
    <TransportSection>
        <Box>
            <Label mb={"25px"} fontStyle="h2">
                Do they require transport?
            </Label>
            <FormField>
                <EditSelect
                    displayName="Pick up address"
                    placeholder="Type name of student or select from dropdown"
                    command={viewModel.updateStudentPickupAddressCommand}
                    options={viewModel.studentAddressOptions}
                    value={() => viewModel.getValue("pickUpAddressId")}
                    validationMessage={() => viewModel.getError("pickUpAddressId")}
                />
            </FormField>
            <FormField mt={"25px"}>
                <EditSelect
                    displayName="Drop off address"
                    placeholder="Type name of student or select from dropdown"
                    command={viewModel.updateStudentDropAddressCommand}
                    options={viewModel.studentAddressOptions}
                    value={() => viewModel.getValue("dropOffAddressId")}
                    validationMessage={() => viewModel.getError("dropOffAddressId")}
                />
            </FormField>
            <FormField mt={"25px"}>
                <EditDate
                    displayName={"Start Time"}
                    value={() => viewModel.startTimeAsDate}
                    command={viewModel.updateStartTimeCommand}
                    mode="time"
                    dateFormat={"HH:mm"}
                    suffix={<ClockIcon />}
                    validationMessage={() => viewModel.getError("startTime")}
                />
            </FormField>
            <FormField mt={"25px"}>
                <EditDate
                    displayName={"End Time"}
                    value={() => viewModel.endTimeAsDate}
                    command={viewModel.updateEndTimeCommand}
                    mode="time"
                    dateFormat={"HH:mm"}
                    suffix={<ClockIcon />}
                    validationMessage={() => viewModel.getError("endTime")}
                />
            </FormField>
        </Box>
    </TransportSection>
));

const AddStudentFooter: React.FC<{ viewModel: AddStudentViewModel; saveCommand: ICommand; closeCommand: ICommand }> = ({ viewModel, saveCommand, closeCommand }) => (
    <Footer>
        <ButtonGroup>
            <Button command={saveCommand} displayName={viewModel.addStudentMentorRotaButtonName} paletteColor="primary" />
            <Button command={closeCommand} displayName={"CANCEL"} paletteColor="secondary" />
        </ButtonGroup>
    </Footer>
);

export default AddStudentView;
